



















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class ErrorModal extends Vue {
  private isActive: boolean = true;
  @Prop({ default: 'Error' }) private title!: string;
  @Prop({ default: 'Sorry, error ocurred' }) private message!: string;
  @Prop(String) private redirectTo: string | undefined;

  private redirect() {
    this.$router.push({ path: this.redirectTo });
  }

  mounted() {
    if (this.redirectTo) {
      setTimeout(() => {
        this.redirect();
        this.isActive = false;
      }, 1300);
    }
  }
}
